import { render, staticRenderFns } from "./magazineDetail.vue?vue&type=template&id=34ff9864&"
import script from "./magazineDetail.vue?vue&type=script&lang=js&"
export * from "./magazineDetail.vue?vue&type=script&lang=js&"
import style0 from "./magazineDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports